import { useQuery } from "@tanstack/react-query";
import { TrendingUp } from "lucide-react";
import { api } from "@/lib/api";

const money = (n) => `$${Number(n || 0).toLocaleString(undefined, { maximumFractionDigits: 0 })}`;

function Tile({ label, value, tone = "text-white", testid }) {
  return (
    <div className="rounded-xl border border-slate-800 bg-[#0d1420] p-4">
      <div className="font-mono-tac text-[10px] uppercase tracking-widest text-slate-500">{label}</div>
      <div className={`mt-1 font-display text-2xl font-black ${tone}`} data-testid={testid}>{value}</div>
    </div>
  );
}

export default function ProjectCosting({ projectId }) {
  const { data } = useQuery({ queryKey: ["project-costing", projectId], queryFn: async () => (await api.get(`/projects/${projectId}/costing`)).data });
  if (!data || !data.jobs?.length) return null;
  const pct = data.margin_pct;
  const tone = pct === null ? "text-slate-400" : pct >= 40 ? "text-emerald-400" : pct >= 20 ? "text-amber-400" : "text-rose-400";
  return (
    <div className="card-tac mt-6 p-5" data-testid="project-costing">
      <div className="mb-4 flex items-center gap-2 font-mono-tac text-xs uppercase tracking-widest text-slate-500"><TrendingUp className="h-4 w-4 text-emerald-400" /> Blended project margin</div>
      <div className="grid gap-3 sm:grid-cols-4">
        <Tile label="Revenue" value={money(data.revenue)} testid="proj-revenue" />
        <Tile label="Cost" value={money(data.cost_total)} testid="proj-cost" />
        <Tile label="Margin" value={money(data.margin)} tone={tone} testid="proj-margin" />
        <Tile label="Margin %" value={pct === null ? " - " : `${pct}%`} tone={tone} testid="proj-margin-pct" />
      </div>
      <div className="mt-4 space-y-1.5">
        {data.jobs.map((j) => (
          <div key={j.job_id} className="flex items-center justify-between rounded-lg border border-slate-800 bg-[#0d1420] px-3 py-2 text-sm" data-testid={`proj-job-${j.job_id}`}>
            <span className="truncate text-slate-200">{j.title}</span>
            <span className="flex items-center gap-4 font-mono-tac text-xs">
              <span className="text-slate-500">{money(j.revenue)}</span>
              <span className={j.margin_pct === null ? "text-slate-500" : j.margin_pct >= 20 ? "text-emerald-400" : "text-rose-400"}>{j.margin_pct === null ? " - " : `${j.margin_pct}%`}</span>
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
